export type Team = typeof team;

export const team = {
  name: "Frontend Developers",
  id: 4312429,
  node_id: "MDQ6VGVhbTQzMTI0Mjk=",
  slug: "developers",
  description: "",
  privacy: "closed",
  url: "https://api.github.com/organizations/74588599/team/4312429",
  html_url: "https://github.com/orgs/care/teams/developers",
  members_url:
    "https://api.github.com/organizations/74588599/team/4312429/members{/member}",
  repositories_url:
    "https://api.github.com/organizations/74588599/team/4312429/repos",
  permission: "pull",
  parent: null,
};
